export default __webpack_public_path__ + "static/media/wow-bg-old.aa26189e.png";